import React from 'react';
import { Box, BoxProps, Typography } from '@mui/material';
import COLORS from '@/resources/style/Themes';
import { COMMON_STYLES } from '../styles';

interface DataRowProps {
  /**
   * The label text to display on the left
   */
  label: string;
  /**
   *  The value/content to display on the right
   */
  children: React.ReactNode;
  /**
   * Additional props to pass to the Box component
   */
  props?: BoxProps;
}

/**
 * Reusable component for displaying label-value pairs in dashboard sections
 */
const DataRow = ({ label, children, ...props }: DataRowProps) => (
  <Box sx={COMMON_STYLES.dataRow} {...props}>
    <Typography variant="body1" sx={{ fontSize: '.95rem', color: COLORS.GREY }}>
      {label}
    </Typography>
    {children}
  </Box>
);

export default DataRow;
